<template>
  <div class="overview-container relative">
    <div class="flex align-items-center" style="margin-bottom: 20px">
      <img
        src="https://logo.wondercv.com/banners/gBLdeRAOsF0quwX.png"
        class="title-icon"
        alt=""
      />
      <span class="title-text">实时校招信息动态</span>
    </div>
    <div class="flex align-items-center overview-content">
      <div class="flex flex-column align-items-center overview-item">
        <span class="overview-number">33</span>
        <span class="overview-text">今日更新</span>
      </div>
      <div class="flex flex-column align-items-center overview-item">
        <span class="overview-number">6</span>
        <span class="overview-text">今日截止</span>
      </div>
      <div class="flex flex-column align-items-center overview-item">
        <span class="overview-number">12353</span>
        <span class="overview-text">累积更新</span>
      </div>
      <div class="flex flex-column align-items-center overview-item">
        <span class="overview-number">3932</span>
        <span class="overview-text">25届校招</span>
      </div>
    </div>
    <div class="member-btn-container">
      <img
        class="member-icon"
        src="https://logo.wondercv.com/banners/r58GYc1b0ctEKxo.png"
        alt=""
      />
      <span class="member-btn-text">开通终身会员即享 180 天校招信息服务</span>
      <div class="btn">立即开通</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
.overview-container {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #fff;
  border-radius: 12px;
  border: 2px solid #fff;
  background: linear-gradient(301deg, #fff 66.23%, #ffece8 100%);
  width: 1200px;
  height: 145px;
  box-sizing: border-box;
  padding: 20px 24px 0 20px;
  .title-icon {
    width: 24px;
    height: 24px;
    margin-right: 8px;
  }
  .title-text {
    color: #000;
    font-family: "PingFang SC";
    font-size: 16px;
    font-weight: 500;
    line-height: normal;
  }
  .overview-content {
    .overview-item {
      flex-direction: column;
      flex-basis: 140px;
      .overview-number {
        color: #f64;
        font-family: "PingFang SC";
        font-size: 26px;
        font-weight: 600;
        line-height: normal;
        margin-bottom: 4px;
      }
      .overview-text {
        color: #606060;
        font-size: 12px;
        line-height: normal;
      }
    }
  }
  .member-btn-container {
    position: absolute;
    bottom: 24px;
    right: 24px;
    padding: 0 16px;
    height: 57px;
    border-radius: 12px;
    border: 1px solid #ffe5e0;
    background: #fff2ef;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    .member-icon {
      width: 32px;
      height: 30px;
      margin-right: 12px;
      object-fit: cover;
    }
    .member-btn-text {
      color: #f64;
      font-size: 14px;
      font-weight: 500;
    }
    .btn {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 20px;
      width: 80px;
      height: 28px;
      border-radius: 100px;
      background: linear-gradient(97deg, #ffbe5d 0.34%, #ff5834 100%);
      color: #fff;
      font-size: 13px;
      font-weight: 500;
      cursor: pointer;
    }
  }
}
</style>
